import myPageApi from '../../api/employee/myPage.js'

export const state = () => ({
  listFavorite: [],
  metadataFavorite: {},
  listHistory: []
})
export const getters = {
}
export const mutations = {
  CHANGE_LIST_FAVORITE (state, slug) {
    state.listFavorite = [...slug]
  },
  CHANGE_METADATA (state, slug) {
    state.metadataFavorite = {...slug}
  },
  CHANGE_LIST_HISTORY (state, slug) {
    state.listHistory = [...slug]
  }
}
export const actions = {
  async getFavorite ({commit}, params) {
    try {
      const res = await myPageApi.getFavorite(params)
      commit('CHANGE_LIST_FAVORITE', res.data.data)
      commit('CHANGE_METADATA', res.data.metadata)
    } catch (error) {

    }
  },
  async getHistory ({commit}, params) {
    try {
      const res = await myPageApi.getHistory(params)
      commit('CHANGE_LIST_HISTORY', res.data.data)
    } catch (e) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/employee/mypage.js